/* eslint-disable no-useless-escape */
/* eslint-disable no-restricted-globals */
export const addParamPageURL = (URL, value, history) => {
  const modifyParamURL = `${URL}?page=${value}`;
  return history.push(modifyParamURL);
};

export const getParamURL = name => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const urlUtil = {
  changePageParams: (URL, value, history) => {
    const modifyParamURL = `${URL}/page/${value}`;
    return history.push(modifyParamURL);
  },
};

export default urlUtil;
